export class GetCosData{
    EduNo: string = ''
    DeptNo: string = ''
    Status: string = ''
    KeyWord: string = ''
    SelKind: string = ''
    OrderBy: string = ''
    FiledsNo: string = ''
}